import ButtonComponent from '@pretto/bricks/components/buttons/Button'
import Illustration from '@pretto/bricks/components/images/Illustration'
import { g } from '@pretto/bricks/components/layout'

import { SimulatorType } from '@pretto/website/src/templates/blocs/components/simulatorRow/SimulatorRow.types'

import styled from 'styled-components'

import * as ILLUSTRATION_PATH from '../../config/illustrations'

type DescriptionIllustrationProps = {
  $projectKind: SimulatorType
}

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.primary1};
  color: ${({ theme }) => theme.colors.white};
  border-radius: ${g(1)};
  padding: ${g(3)};
  position: relative;
`
export const DescriptionIllustrationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${g(3)};
`
export const DescriptionIllustration = styled(Illustration).attrs<DescriptionIllustrationProps>(({ $projectKind }) => ({
  height: 104,
  path: ILLUSTRATION_PATH[$projectKind],
  width: 104,
}))`
  width: 104px;
  height: 104px;
`

export const Button = styled(ButtonComponent).attrs({ isSecondary: true })`
  margin: ${g(3)} 0;
  width: 100%;
`
